export const NEW_LINE_CHARACTER = '%0D%0A'
